var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"card-company-table"},[_c('b-card-header',[_c('h5',[_vm._v(_vm._s(_vm.title))])]),_c('b-table',{staticClass:"mb-0",attrs:{"items":_vm.tableData,"responsive":"","fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }